import mapJson from 'jsonpath-mapper';
import path from 'path';
import { Node } from 'contensis-management-api';
import { Node as DeliveryNode } from 'contensis-delivery-api';

import ContensisRepository from '~/repositories/ContensisRepository';
import { getParentPath } from '~/util/path';

export const mapSourceNodeToTargetNode = (
  target: ContensisRepository,
  node: DeliveryNode,
  inputParentId?: string
): Node => {
  const language = target.project?.primaryLanguage
    ? target.project.primaryLanguage
    : 'en-GB';
  return mapJson(node, {
    id: {
      $path: 'id',
      $formatting: (id) =>
        node.path === '/'
          ? // Retain existing root node id from the target repo
            target.nodes.tree?.id
          : // TODO: update node.path to targetNode.path to support partial tree
            // imports to a new location
            target.transformGuid(id, node.path),
    },
    parentId: {
      $path: 'parentId',
      $return: (guid) => {
        if (inputParentId) return inputParentId;
        if (guid) {
          return target.transformGuid(guid, getParentPath(node.path));
        }
        return null;
      },
    },
    projectId: () => target.projectId,
    slug: {
      [language]: {
        $path: [`slug.${language}`, 'slug'],
        $return: (slug) => slug || path.basename(node.path),
      },
    },
    displayName: {
      [language]: [`displayName.${language}`, 'displayName', 'title'],
    },
    entryId: {
      $path: ['entryId', 'entry.sys.id'],
      $formatting: (id) => target.transformGuid(id),
    },
    isCanonical: 'isCanonical',
    restrictedToLanguages: 'restrictedToLanguages',
    renderer: 'renderer',
    proxy: 'proxy',
    includeInMenu: 'includeInMenu',
  });
};
